'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visitorErrorMiddleware = undefined;

var _isErrorAction = require('conversations-error-reporting/error-actions/operators/isErrorAction');

var _captureActionBreadcrumb = require('conversations-error-reporting/error-reporting/captureActionBreadcrumb');

var _reportErrorAction = require('conversations-error-reporting/error-reporting/reportErrorAction');

var visitorErrorMiddleware = exports.visitorErrorMiddleware = function visitorErrorMiddleware() {
  return function (next) {
    return function (action) {
      (0, _captureActionBreadcrumb.captureActionBreadcrumb)(action);

      if ((0, _isErrorAction.isErrorAction)(action)) {
        (0, _reportErrorAction.reportErrorAction)(action);
      }

      return next(action);
    };
  };
};